module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "structure-imgs1"
  }, [_c('img', {
    staticClass: "_idgenobjectattribute5",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/image-216.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("The Middle Aisles")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("This is the scariest part of the grocery store—prepackaged foods, sauces, snacks, breads, and more, loaded with inflammatory plant-based oils, nasty preservatives, added sugar, artificial flavors, gluten, and more. But once you learn how to shop, which I will teach you, you will be able to avoid all that stuff and focus on the Bobby Approved products that are made with best-in-class"), _c('span'), _vm._v("in"), _c('span', [_vm._v("gredients.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("This book Is 100% Gluten Free")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Not because I’m allergic, it’s because gluten is inflammatory, and we keep a keto and paleo house for the most part. If you want the best bread at the store, go for organic and sprouted bread. Search “FlavCity bread” on YouTube to learn lots more! There are lots of garbage gluten-free products at the store. I will show you how to choose the best-quality, most nutrient-de"), _c('span', [_vm._v("nse")]), _c('span'), _c('span', [_vm._v("items.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Processed Oils")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Stay away from any product that uses canola, soybean, corn, sunflower, or safflower oil. These are highly processed oils that are usually made from GMO crops and are very inflammatory. The problem is most ready-bought items use these oils, and the reason is because they are cheap! You will notice that I only cook with avocado, virgin coconut, and olive oil, and the Bobby Approved products used for these recipes contain only the best oils and other ingredients. Search “FlavCity cooking oil” on YouTube for lots more"), _c('span'), _vm._v("in"), _c('span', [_vm._v("formation.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Cane Sugar Is the Devil!")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("It not only makes us fat, but it also kills good gut bacteria and is inflammatory. It’s amazing what happens to your body when you stop eating sugar along with other inflammatory foods. You start to lose weight and feel great! I have a fantastic video about the most inflammatory foods at the store. Search “FlavCity inflammation” on YouTube. There are incredible paleo sweeteners like maple syrup and honey, and keto sweeteners like monk fruit. These are the types of sweeteners we use in this book and what you want to have in your pantry. Search “FlavCity sweeteners” on YouTube. These videos have loads of"), _c('span'), _vm._v("in"), _c('span', [_vm._v("formation.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Produce")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("I highly advise you to buy organic produce when it comes to the dirty dozen. These fruits and veggies are some of the most highly sprayed crops and scary levels of chemicals persist even after was"), _c('span', [_vm._v("hing")]), _c('span'), _c('span', [_vm._v("them!")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body1",
    attrs: {
      "id": "calibre_pb_27"
    }
  }, [_vm._v("(Check out EWG.com, they have excellent information of th"), _c('span', [_vm._v("is")]), _c('span'), _c('span', [_vm._v("topic.)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30318df2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_016.vue
// module id = 105
// module chunks = 0